import Vue from 'vue';
import Errors from '../classes/errors';
import { isCaptchaEnabled } from '../services/captcha';
import { setCaptchaEuScript } from '../utils';
import { getFormRenderToken } from '../services/anti-bot';

Vue.component('business-fleet-form-wrapper-component', {
    props: {
        formType: {
            type: String,
        },
        siteHandle: {
            type: String,
        },
        // getBrandStoresForSite() returns a PHP array keyed by store id, which
        // serializes to a JSON object — not an array — so the prop is an Object.
        stores: {
            type: Object,
            default: () => ({}),
        },
        isModalOpen: {
            type: Boolean,
            default: false,
        },
        captchaEuPublicKey: {
            value: String,
        },
    },

    data() {
        return {
            formRenderToken: '',
            errors: new Errors(),
            submitting: false,
        };
    },

    watch: {
        isModalOpen(isOpen) {
            if (!isOpen) {
                this.resetForm();
            }
        },
    },

    mounted() {
        setCaptchaEuScript();

        getFormRenderToken().then((token) => {
            this.formRenderToken = token;
        });
        window.addEventListener('keydown', this.onEsc);
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onEsc);
    },

    methods: {
        resetForm() {
            const form = this.$refs.form;

            if (!form) return;

            form.querySelectorAll('input').forEach((el) => {
                if (el.type === 'checkbox') {
                    el.checked = false;
                } else if (el.name !== 'action' && el.type !== 'hidden') {
                    el.value = '';
                    el.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            form.querySelectorAll('textarea').forEach((el) => {
                el.value = '';
                el.dispatchEvent(new Event('input', { bubbles: true }));
            });

            form.reset();
            this.isCheckboxChecked = false;
            this.errors.clear();
        },

        onEsc(e) {
            if (e.key === 'Escape') {
                this.handleCloseModal();
            }
        },

        handleCloseModal() {
            EventBus.$emit('closeModal');
        },

        async onSubmit(event) {
            event.preventDefault();
            const form = event.currentTarget;

            if (this.submitting) return;

            this.submitting = true;

            try {
                if (!(await isCaptchaEnabled())) {
                    await this.handleDataSubmit(form);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(form, captchaSolution);
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, captchaSolution) {
            try {
                const formData = new FormData(form);
                formData.append('formRenderToken', this.formRenderToken);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }

                const response = await axios.post('/', formData);
                const result = response.data;

                // Handle form errors.
                if (result.data.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);
                    this.submitting = false;
                    return;
                }

                this.handleCloseModal();
            } catch (e) {
                throw new Error(e);
            }
        },
    },
});
